<template>
    <div>
        <ctlHomeNav></ctlHomeNav>
        <v-container fluid >
            <!--20210901, per Chris, I will hold on this feature 
                <div>
                <div v-for="contr in contracts" :key="contr.id">
                    {{contr.gpo}}
                    -
                    {{contr.contractNo}}
                    -
                    <v-btn @click="$router.push({ name: 'contract-hotsheet', params: { id: contr.id } })">Hot Sheet</v-btn>

                </div>
            </div> -->
            <v-layout align-start wrap>
                <ctlFolderFileNavTree></ctlFolderFileNavTree>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import ctlHomeNav from '@/components/ctlHomeNav'
import ctlFolderFileNavTree from '@/components/tools/ctlFolderFileNavTree'
export default {
    components: {
        ctlHomeNav,
        ctlFolderFileNavTree,
    },
    data() {
        return {
            contracts: [
                {
                    id: 1000,
                    contractNo: 'qa-2123',
                    gpo: 'Vizient',
                }
            ]
        }
    }
}
</script>